class TabsSection extends HTMLElement {
  constructor() {
    super();
    this.list = this.querySelector('.tabs__list');
    this.panels = Array.from(this.querySelectorAll('.tabs__panel'));

    if (this.list && this.panels.length) {
      this.initButtons();
    }
  }

  initButtons() {
    this.panels.forEach((panel, index) => {
      const tabId = panel.dataset.tabId;
      const tabName = panel.dataset.tabName || 'Tab';
      if (!tabId) return;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'tabs__tab' + (index === 0 ? ' is-active' : '');
      button.setAttribute('role', 'tab');
      button.id = 'tab-' + tabId;
      button.dataset.tabId = tabId;
      button.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
      button.setAttribute('aria-controls', 'tab-panel-' + tabId);
      button.textContent = tabName;

      button.addEventListener('click', this.onTabClick.bind(this));
      this.list.appendChild(button);
    });

    if (this.panels[0]) {
      this.panels[0].classList.add('is-active');
    }

    this.tabs = this.list.querySelectorAll('.tabs__tab');
  }

  onTabClick(evt) {
    const button = evt.currentTarget;
    const tabId = button.dataset.tabId;
    if (!tabId) return;

    this.tabs = this.list.querySelectorAll('.tabs__tab');
    this.tabs.forEach((t) => {
      t.classList.remove('is-active');
      t.setAttribute('aria-selected', 'false');
    });
    this.panels.forEach((p) => {
      p.classList.remove('is-active');
    });

    button.classList.add('is-active');
    button.setAttribute('aria-selected', 'true');

    const panel = this.querySelector('#tab-panel-' + tabId);
    if (panel) {
      panel.classList.add('is-active');
    }
  }
}

customElements.define('tabs-section', TabsSection);
